import { render } from "./PlayerModal.vue?vue&type=template&id=fb5de964"
import script from "./PlayerModal.vue?vue&type=script&lang=js"
export * from "./PlayerModal.vue?vue&type=script&lang=js"

import "./PlayerModal.vue?vue&type=style&index=0&id=fb5de964&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__